import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import { EDITING_DOCUMENT__FIELD_CREATE, PDF_CLEAR_ALL_STATE } from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';
import FieldType from '@app/store/FieldType';

export interface EditingDocumentLatestFieldIDByTypeState {
  [FieldType.CHECKBOX_FIELD]: string | null;
  [FieldType.CHECKBOX_GROUP]: string | null;
  [FieldType.SIGNATURE_FIELD]: string | null;
  [FieldType.TEXT_FIELD]: string | null;
  [FieldType.ROOT]: string | null;
}

const initialState: EditingDocumentLatestFieldIDByTypeState = {
  [FieldType.CHECKBOX_FIELD]: null,
  [FieldType.CHECKBOX_GROUP]: null,
  [FieldType.SIGNATURE_FIELD]: null,
  [FieldType.TEXT_FIELD]: null,
  [FieldType.ROOT]: null,
};

export default function reducer(
  state: EditingDocumentLatestFieldIDByTypeState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { fieldType, uuid } = action.payload.information;
        draft[fieldType] = uuid;
      });
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
